import api from "./api";
import type { PushSubscriptionType } from "../shared/interfaces/PushInterface";

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from(rawData, (char) => char.charCodeAt(0));
}

export const subscribeUser = async (): Promise<void> => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.error("Ce navigateur ne supporte pas les notifications push.");
    return;
  }

  try {
    await navigator.serviceWorker.register('/sw.js');
    const registration = await navigator.serviceWorker.ready;

    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      const nativeJson = existingSubscription.toJSON();
      const payload: PushSubscriptionType = {
        endpoint: nativeJson.endpoint,
        keys: {
          p256dh: nativeJson.keys?.p256dh,
          auth: nativeJson.keys?.auth
        }
      };
      await api.post("/notifications/subscribe", payload);
      return;
    }

    const publicVapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
    if (!publicVapidKey) {
      console.error("Erreur : La clé VITE_VAPID_PUBLIC_KEY n'est pas définie dans le fichier .env");
      return;
    }

    const applicationServerKey = urlBase64ToUint8Array(publicVapidKey);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey as unknown as BufferSource
    });


    const nativeJson = subscription.toJSON();
    const payload: PushSubscriptionType = {
      endpoint: nativeJson.endpoint,
      keys: {
        p256dh: nativeJson.keys?.p256dh,
        auth: nativeJson.keys?.auth
      }
    };
    await api.post("/notifications/subscribe", payload);

  } catch (error: any) {
    if (error.name === 'NotAllowedError') {
      console.error("L'utilisateur a refusé ou bloqué les notifications.");
    } else {
      console.error("Échec du processus d'abonnement :", error.response?.data || error.message);
    }
  }
};